import { render, staticRenderFns } from "./PatientComplexReports.vue?vue&type=template&id=ec8b420c&scoped=true"
import script from "./PatientComplexReports.vue?vue&type=script&lang=js"
export * from "./PatientComplexReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8b420c",
  null
  
)

export default component.exports